<!--
 * @Author: zhaoliang
 * @Date: 2023-04-10 11:47:22
 * @LastEditTime: 2026-02-26 12:15:00
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/SignUpMFA/index.vue
 *
-->
<template>
  <div :class="['signup-module', $i18n.locale === 'fr_CA' ? 'signup-box-bgfr' : 'signup-box-bgen']">
    <div class="signup-box" :style="{ minHeight: minHeight }">
      <div v-if="currentStep !== 5" class="signup-box-layout">
        <div class="signup-box-help">
          <div class="progress-bar">
            <div class="progress-point">
              <div :class="{ active: currentStep >= 1 }"></div>
              <div :class="{ active: currentStep >= 2 }"></div>
              <div :class="{ active: currentStep >= 3 }"></div>
              <div :class="{ active: currentStep >= 4 }"></div>
            </div>
            <div class="progress-line">
              <div :class="{ active: currentStep >= 2 }"></div>
              <div :class="{ active: currentStep >= 3 }"></div>
              <div :class="{ active: currentStep >= 4 }"></div>
            </div>
          </div>
          <img
            src="~img/help.png"
            alt="help"
            v-if="!showTips"
            @click="
              () => {
                this.showTips = !this.showTips;
              }
            "
          />
          <div class="signup-box-close" v-if="showTips">
            <img
              src="~img/close.png"
              alt="close"
              @click="
                () => {
                  this.showTips = !this.showTips;
                }
              "
            />
          </div>
          <div class="signup-help" v-if="showTips">
            <h2>{{ $i18n.t('tips-title') }}</h2>
            <template v-if="currentStep === 1">
              <p v-for="(item, index) in step1TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <i18n-t v-if="item.linktext" :keypath="item.description" tag="span">
                  <a
                    :href="$i18n.locale === 'fr_CA' ? item.frurl : item.enurl"
                    target="_blank"
                    style="cursor: pointer; text-decoration: underline; font-weight: 700"
                  >
                    {{ $i18n.t(item.linktext) }}
                  </a>
                </i18n-t>
                <span v-else>{{ $i18n.t(item.description) }}</span>
              </p>
            </template>
            <template v-if="currentStep === 2">
              <p v-for="(item, index) in step2TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
            <template v-if="currentStep === 3">
              <p v-for="(item, index) in step3TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
            <template v-if="currentStep === 4">
              <p v-for="(item, index) in step4TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
          </div>
        </div>
        <Step1 v-if="currentStep === 1" class="signup-step1" @nextStep="nextStep1" />
        <Step2 v-if="currentStep === 2" class="signup-step2" @nextStep="nextStep2" />
        <div v-if="currentStep === 3" class="signup-step3">
          <Captcha
            ref="captcha"
            @handleResend="handleResend"
            @handleDone="handleDone"
            @handleFinish="handleFinish"
            @handleSkip="handleSkip"
            :loading="loading"
            :errMsg="errCaptchaMsg"
            :bottomline="canChangeAuthtype"
            :isShowAsk="true"
          >
            <template #title>
              <img src="~img/icon-lock-black.svg" alt="lock" />
              <span v-if="authType === 1">{{ $t('signup-captcha-title1') }}</span>
              <span v-else>{{ $t('signup-captcha-title2') }}</span>
            </template>
            <template #desc>{{ $t('signup-captcha-desc') }}</template>
            <template #info>{{ captchaInfo }}</template>
          </Captcha>
          <div v-if="canChangeAuthtype">
            <div class="code-bottom" v-if="authType === 2" @click="changeAuthType(1)">
              <img
                class="email-logo"
                src="@/components/LeftAccount/images/icon-email.svg"
                alt="email logo"
              />
              <span class="code-to-email">{{ $i18n.t('code-auth-toemail') }}</span>
            </div>
            <div class="code-bottom" v-if="authType === 1" @click="changeAuthType(2)">
              <img
                class="phone-logo"
                src="@/components/LeftAccount/images/icon-phone.svg"
                alt="phone logo"
              />
              <span class="code-to-phone">{{ $i18n.t('code-auth-tophone') }}</span>
            </div>
          </div>
        </div>
        <Step4
          v-if="currentStep === 4"
          class="signup-step4"
          @nextStep="nextStep4"
          :errMsg="errorMsg"
        />
      </div>
      <div v-if="currentStep === 5" class="signup-success">
        <h2 class="title">{{ $i18n.t('congratulations') }}</h2>
        <div class="desc1">{{ $i18n.t('activated') }}</div>
        <div class="card">
          <!-- <img
            class="card-logo"
            v-if="cardData.bankLogo"
            :src="cardData.bankLogo"
            alt="bank logo"
          /> -->
          <img
            v-if="$i18n.locale === 'en_US'"
            src="~img/new-logo-visa2.png"
            class="card-logo"
            alt="bank logo"
          />
          <img
            v-if="$i18n.locale === 'fr_CA'"
            src="~img/new-logo-visa2-fr.png"
            class="card-logo"
            alt="bank logo"
          />
          <!-- <img class="card-logo" src="~img/new-logo-visa2.png" alt="bank logo" /> -->
          <p class="membership-no">{{ $i18n.t('signup-success-no') }}</p>
          <p class="dragonpass-code" v-if="cardData.dragoncode">{{ cardData.dragoncode }}</p>
        </div>
        <div class="desc2">
          {{ $i18n.t('signup-success-desc1') }}
        </div>
        <div class="desc2">
          {{ $i18n.t('signup-success-desc2') }}
        </div>
        <!-- 按钮部分 -->
        <button class="go-home-button" @click="goHome">{{ $t('signup-success-btn') }}</button>
        <!-- <div class="go-home-button">
          <div @click="goHome" role="button">{{ $t('homePage') }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import Step1 from './components/step1/index.vue';
  // import step1TipsConfig from './components/step1/tipsConfig.js';
  import {
    step1TipsConfig,
    step2TipsConfig,
    step3TipsConfig,
    step4TipsConfig,
  } from './tipsConfig.js';
  import Step2 from './components/step2/index.vue';
  // import step2TipsConfig from './components/step2/tipsConfig.js';
  // import step3TipsConfig from './components/step3/tipsConfig.js';
  import Captcha from '../Login/Captcha.vue';
  import Step4 from './components/step4/index.vue';
  // import step4TipsConfig from './components/step4/tipsConfig.js';
  import Congratulations from '../SignUp/componets/Step4';
  import { v4 as uuid } from 'uuid';
  import { getEmailBeforeAt, getFirst4andLast2Num, encryptAES } from '@/utils';
  import store from '@/store';
  import { mapMutations } from 'vuex';
  import { formatCardNo } from '@/components/BaseUi/Form/utils/index';

  // 非响应式数据不需要放在data中，提升性能
  const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
  export default {
    name: 'SignUpMFA',
    components: { Step1, Step2, Captcha, Step4, Congratulations },
    props: {
      minHeight: {
        type: String,
        default: '0px',
      },
    },
    data() {
      return {
        cardData: {},
        currentStep: 1, // 1：银行卡信息  2: 个人信息 3: 手机/邮箱验证 4:创建密码
        step1TipsConfig,
        step2TipsConfig,
        step3TipsConfig,
        step4TipsConfig,
        loading: false,
        showTips: false,
        errorMsg: '',
        errCaptchaMsg: '',
        mfaDetail: {
          callPrefix: '',
          phone: '',
          email: '',
        },
        authType: 2, // 1-邮件 2-手机
        authKey: '',
        canChangeAuthtype: true,
        isChecked: false, // 三星手机自带浏览器的自动登录功能会跳过check接口
        cardInfoToken: '',
        userRegisterToken: '',
        myCardData: {
          bankLogo: '',
          droganCode: '1234 5678 1234 5678',
        },
        loginpsw: '',
        loginOtpToken: '',
      };
    },
    computed: {
      desensitizedPhone() {
        const { callPrefix, phone } = this.mfaDetail;
        const phEx = `+${callPrefix}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return phone ? `${phEx} ${getFirst4andLast2Num(newPhone)}` : '';
      },
      desensitizedEmail() {
        const { email } = this.mfaDetail;
        return email ? getEmailBeforeAt(email) : '';
      },
      captchaInfo() {
        return this.authType === 1 ? this.desensitizedEmail : this.desensitizedPhone;
      },
    },
    methods: {
      ...mapMutations(['showMessageModal']),
      nextStep1({ newstep = 2, cardInfoToken = this.cardInfoToken }) {
        this.currentStep = newstep;
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // 平滑滚动效果
        });
        // 注册时需要用到
        this.cardInfoToken = cardInfoToken;
      },
      nextStep2({ newstep = 3, formData = this.mfaDetail }) {
        this.mfaDetail = {
          callPrefix: formData.dialCode,
          phone: formData.phone,
          email: formData.email,
          firstName: formData.fname,
          lastName: formData.lname,
          allowTracking: formData.allowTracking,
          allowReceiving: formData.allowReceiving,
        };
        this.authType = 2;
        // 验证码发送成功后才进入 OTP 步骤；发送失败时停留在当前步骤，由 sendAuthCode 弹窗提示
        this.sendAuthCode(this.authType, () => {
          this.currentStep = newstep;
          this.$nextTick(() => {
            this.$refs.captcha?.notify();
          });
        });
      },
      handleSkip() {
        console.log('ask me later');
        this.currentStep = 4;
      },
      nextStep4({ password }) {
        // 注册
        this.$loading.show();
        this.loginpsw = password;
        const { callPrefix, phone, email, firstName, lastName, allowTracking, allowReceiving } =
          this.mfaDetail;
        const deviceId = localStorage.getItem('deviceId') || uuid();
        localStorage.setItem('deviceId', deviceId);
        const data = {
          email,
          exphone: callPrefix,
          password,
          lang: this.$i18n.locale,
          firstName,
          lastName,
          phone,
          userRegisterToken: this.userRegisterToken,
          cardInfoToken: this.cardInfoToken,
          deviceId,
          allowTracking,
          allowReceiving,
        };
        this.$http.login.registerMFA(data).then(async res => {
          if (res.state === '11') {
            this.loginOtpToken = res.data.loginOtpToken;
            await this.userLoginAndGetDragonCard();
          } else {
            this.errorMsg = res.note;
          }
        });
      },
      handleResend(callback) {
        if (!this.captchaInfo) return;
        this.sendAuthCode(this.authType, callback);
      },
      changeAuthType(authType) {
        if (!this.captchaInfo) return;
        this.sendAuthCode(authType, () => {
          this.authType = authType;
        });
      },
      handleFinish(data) {
        console.log('finish', data);
        this.errCaptchaMsg = '';
      },
      handleDone(authCode) {
        console.log('done');
        const { email, callPrefix, phone } = this.mfaDetail;
        const deviceId = localStorage.getItem('deviceId') || uuid();
        localStorage.setItem('deviceId', deviceId);
        const data = {
          lang: this.$i18n.locale,
          authType: this.authType,
          authCode,
          email,
          callPrefix,
          phone,
          deviceId,
        };
        this.$http.login
          .checkRegisterAuthCode(data)
          .then(res => {
            if (res.state === '11') {
              // const oldFlag = this.canChangeAuthtype;
              this.canChangeAuthtype = false;
              this.userRegisterToken = res.payload.userRegisterToken;
              this.$refs.captcha.showSuccess(() => {
                this.currentStep = 4;
                // this.canChangeAuthtype = oldFlag;
              });
            } else {
              if (res.errorCode === 'opt.code.error') {
                this.errCaptchaMsg = this.$i18n.t('code-auth-notmatch');
              } else if (res.errorCode === 'error.6.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-1'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.step = 1;
                  },
                });
              } else if (res.errorCode === 'auth.error.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-3'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-3'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.step = 1;
                  },
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      sendAuthCode(authType, successCallback) {
        // this.authType = authType;
        const { email, callPrefix, phone } = this.mfaDetail;
        const deviceId = localStorage.getItem('deviceId') || uuid();
        localStorage.setItem('deviceId', deviceId);
        const data = {
          deviceId,
          authType,
          email,
          callPrefix,
          phone,
          lang: this.$i18n.locale,
        };
        this.$http.login
          .sendRegisterAuthCode(data)
          .then(res => {
            // 5xx 等异常已由请求层统一弹窗，此处避免重复提示
            if (!res) return;
            if (res?.state === '11') {
              // code sent
              // this.authKey = res.payload.key;
              successCallback && successCallback();
              return;
            }
            // 错误码处理
            if (res?.errorCode === 'retry.after.1.min') {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-4'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
              });
            } else if (res?.errorCode === 'error.6.locked.30') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-3'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-3'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.step = 1;
                },
              });
            } else if (res?.errorCode === 'too.many.requests') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-2'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-2'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.step = 1;
                },
              });
            } else {
              // 未匹配的错误码（含后端新增风控提示）统一弹窗，避免静默失败
              this.showSendAuthCodeError(res);
            }
          })
          .catch(err => {
            console.error(err, 'sendRegisterAuthCode');
            // 超时与 5xx 已在请求层统一弹窗，这里兜底其他网络异常
            const errorMsg = String(err?.message || '').toLowerCase();
            if (!errorMsg.includes('timeout')) {
              this.showSendAuthCodeError();
            }
          });
      },
      // 发送注册验证码失败的统一提示
      showSendAuthCodeError(res) {
        const note = res?.note || res?.errorCode;
        // 语言包为扁平结构（key 可能带点号），后端返回的也可能是已翻译文案
        const localeMessages = this.$i18n.getLocaleMessage?.(this.$i18n.locale) || {};
        const isI18nKey = !!note && Object.prototype.hasOwnProperty.call(localeMessages, note);
        this.$messageModal.show({
          image: false,
          closeIcon: true,
          desc: note || this.$i18n.t('please-try-again'),
          i18nNeed: isI18nKey,
          confirmBtn: this.$i18n.t('ok'),
          justHide: true,
        });
      },
      handleLogin(data) {
        this.$loading.show();

        return new Promise(resolve => {
          this.$http.login
            .userLogin(data)
            .then(res => {
              if (res.state === '11') {
                this.$loading.hide();
                sessionStorage.setItem('token', encryptAES(res.user.sessionId));
                // sessionStorage.setItem('sessionId', encryptAES(res.user.sessionId));
                sessionStorage.setItem('isLogin', true);
                sessionStorage.setItem('user', encryptAES(JSON.stringify(res.user)));
                store.commit('setState', {
                  state: 'isLogin',
                  values: true,
                });
                store.commit('setState', {
                  state: 'userInfo',
                  values: res.user,
                });
                if (res.visaCardType) {
                  sessionStorage.setItem('visaCardType', res.visaCardType);
                  store.commit('setState', {
                    state: 'visaCardType',
                    values: res.visaCardType,
                  });
                }
                resolve(res);
              } else if (res.state === '00') {
                this.$loading.hide();
                res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
              }
            })
            .catch(err => {
              console.error(err);
              this.$loading.hide();
            });
        });
      },
      // 获取龙腾卡信息
      getDragonCard(data) {
        this.$loading.show();
        return new Promise(resolve => {
          this.$http.login.getDragonCard(data).then(
            res => {
              if (res.state === '11') {
                this.$loading.hide();
                resolve(res);
              } else if (res.state === '00') {
                this.$loading.hide();
                res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
              }
            },
            err => {
              console.error(err);
              this.$loading.hide();
            },
          );
        });
      },
      // 获取用户信息同时获取龙腾卡信息
      async userLoginAndGetDragonCard() {
        const { email } = this.mfaDetail;
        const deviceId = localStorage.getItem('deviceId') || uuid();
        localStorage.setItem('deviceId', deviceId);
        const loginData = {
          password: this.loginpsw,
          username: email,
          version: '1.0.0',
          device: 'web',
          deviceName,
          loginOtpToken: this.loginOtpToken,
          deviceId,
        };

        const successLogin = await this.handleLogin(loginData);

        // 通过用户信息获取到龙腾卡信息
        const { userId, sessionId } = successLogin.user;
        const dragonCardData = {
          lang: this.$i18n.locale,
          device: 'web',
          version: '1.0.0',
          userId,
          sessionId,
          deviceName,
        };

        const dragonCardMsg = await this.getDragonCard(dragonCardData);
        if (dragonCardMsg.state === '11') {
          this.$loading.hide();
          const { bankLogo, bankLogoThumbnails, englishName, dragoncode, cardValidDate } =
            dragonCardMsg.card;
          // const [year, month, day] = validDate.split('-');
          // const formatValidData = `${day}/${month}/${year}`;
          const formatDragoncode = formatCardNo(dragoncode);
          this.cardData = {
            cardValidDate,
            bankLogo,
            bankLogoThumbnails,
            englishName,
            dragoncode: formatDragoncode,
            // validData: formatValidData,
          };
          this.currentStep = 5;
        } else {
          console.error(dragonCardMsg.note);
          this.$loading.hide();
        }
      },
      goHome() {
        this.$router.push('/');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile.scss';
</style>
